/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`)
  }
}

export const shouldUpdateScroll = args => {
  const windowWidth = window.innerWidth

  // Prevent scroll on large screen - helps with react-modal / lightbox
  if (windowWidth < 750) {
    return true
  } else {
    return false
  }
}
